/**
 * @generated SignedSource<<f451f788e4aa07e1f305ae61df138416>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InternBrandStyleFavicon_brand$data = {
  readonly id: string;
  readonly internStyle: {
    readonly favicon: string | null;
  } | null;
  readonly " $fragmentType": "InternBrandStyleFavicon_brand";
};
export type InternBrandStyleFavicon_brand$key = {
  readonly " $data"?: InternBrandStyleFavicon_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"InternBrandStyleFavicon_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InternBrandStyleFavicon_brand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InternBrandStyle",
      "kind": "LinkedField",
      "name": "internStyle",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "favicon",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "17ae406bdedb91d0dd148da9cc31cb4c";

export default node;
